import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
// import { LoginService } from "../login.service";

@Component({
  selector: "app-app-contracts",
  templateUrl: "./app-contracts.component.html",
  styleUrls: ["./app-contracts.component.scss"],
})
export class AppContractsComponent implements OnInit {
  public officeClient: Array<any> = new Array<any>();
  public debtor: any;

  constructor(
    public dialogRef: MatDialogRef<AppContractsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.debtor = this.data[0].debtor;
  }

  selectContract(contract: any) {
    const data = { contract, officeClient: this.officeClient };
    this.dialogRef.close(data);
  }
}
